/**
 * Whether the element's focus came from the keyboard, or from a script acting
 * on a keypress, rather than from a pointer press. Browsers without
 * :focus-visible count every focus.
 */
export function isKeyboardFocus(target: Element) {
   try {
      return target.matches(':focus-visible');
   } catch {
      return true;
   }
}
